"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KBL = void 0;
exports.KBL = {
    id: 'kbl',
    companyName: 'Kukbo Logix',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'kbl',
    },
    isInternal: false,
    isActive: true,
    countries: ['KR'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS0JMLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL0tCTC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLEdBQUcsR0FBVTtJQUN0QixFQUFFLEVBQUUsS0FBSztJQUNULFdBQVcsRUFBRSxhQUFhO0lBQzFCLGNBQWMsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUN2QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUsS0FBSztLQUNmO0lBQ0QsVUFBVSxFQUFFLEtBQUs7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9